import { connect } from 'react-redux';
import DuplicateModal from '../duplicate/DuplicateModal';
import { duplicateBoiler } from '../../redux/boiler/boiler_actions';

const mapStateToProps = state => ({
  isDuplicating: state.hotWaterSystem.boiler.isDuplicating,
  errorMessage: state.hotWaterSystem.boiler.errorMessage,
});

const mapDispatchToProps = dispatch => ({
  duplicate: (id, name) => dispatch(duplicateBoiler(id, name)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DuplicateModal);



// WEBPACK FOOTER //
// ./src/modal/boiler/BoilerDuplicateModal.js